import React from 'react';
import loadable from '@loadable/component';
import { CatalogItemType } from '@common/model/catalog/item/type';
import { CatalogItemViewContext, ICatalogItemViewContext } from 'src/entities/catalog/item';

const ResumeView = loadable(() => import('./view.resume'));
const VacancyView = loadable(() => import('./view.vacancy'));

const value: ICatalogItemViewContext = {
  [CatalogItemType.Resume]: ResumeView,
  [CatalogItemType.Vacancy]: VacancyView,
};

export const CatalogItemViewsProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <CatalogItemViewContext.Provider value={value}>{children}</CatalogItemViewContext.Provider>;
};
